import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight, AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 pt-32 pb-20 bg-brand-surface" data-testid="page-not-found">
      <div className="text-center max-w-xl">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-brand-navy text-white flex items-center justify-center mb-6">
          <AlertCircle className="w-8 h-8" />
        </div>
        <div className="font-heading font-extrabold text-7xl lg:text-8xl text-brand-navy leading-none">404</div>
        <h1 className="font-heading font-extrabold text-2xl sm:text-3xl text-brand-navy mt-4">
          Pagina non trovata
        </h1>
        <p className="mt-3 text-brand-muted text-lg leading-relaxed">
          La pagina che stai cercando non esiste o è stata spostata. Torna alla home oppure parla con un tutor del Polo.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary" data-testid="notfound-home-cta">
            <Home className="w-4 h-4" /> Torna alla Home
          </Link>
          <Link to="/contatti" className="btn-secondary" data-testid="notfound-contatti-cta">
            Contattaci <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
